<template>
  <div>
    <!--class="container" -->
    <br /><br />
    <center>
      <div>
        <button class="button" id="btPrint" @click="createPDF()">
          <span>
            <v-icon>mdi-printer</v-icon>&nbsp;&nbsp;{{
              $t("applicant_info_add.click_to_print")
            }}&nbsp;</span
          >
        </button>
      </div>
      <br /><br />
    </center>
    <br /><br />
    <div id="tab">
      <table class="center">
        <tr>
          <td width="15%" rowspan="3" align="center">
            <img src="kmitl_logo3.gif" />
          </td>
          <td colspan="2">
            <strong
              >สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง<br />
              <span class="english-text"
                >(King Mongkut's Institute of Technology Ladkrabang)</span
              ></strong
            >
          </td>
          <td rowspan="4" align="right">
            <table class="sub-table">
              <tr style="line-height: 84px" align="center">
                <td width="50px">
                  <span class="english-text"> รูปถ่าย 1 นิ้ว </span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            สำนักทะเบียนและบริการการศึกษา
            <span class="english-text"
              >(KMITL Registration and Educational Service Office)</span
            >
          </td>
        </tr>
        <tr>
          <td colspan="1">
            ใบสมัคร<br />
            <span class="english-text">Application</span>
          </td>
          <td width="50%" align="left">
            วันที่สมัคร : {{ dateFromDBTranslatorTH(created_at) }}<br /><span
              class="english-text"
              >Date of application :
              {{ dateFromDBTranslatorEN(created_at) }}</span
            >
          </td>
        </tr>
        <tr>
          <td colspan="2">
            สำหรับนักศึกษาระดับ{{ level_name_th }} (<span
              class="english-text"
              >{{ level_name_en }}</span
            >)
          </td>
          <td align="left">
            เลขที่สมัคร&nbsp;<span class="english-text">(Registration No.)</span
            >&nbsp;&nbsp;{{ registId }}
          </td>
        </tr>
        <tr>
          <td colspan="2" align="left">
            เลขบัตรประชาชน&nbsp;<span class="english-text"
              >(ID card number)</span
            >&nbsp;&nbsp;{{ Citizen_id }}
          </td>
          <td align="left" colspan="2">
            ชื่อ – สกุล&nbsp;<span class="english-text">(Name-Surname)</span
            >&nbsp;&nbsp;{{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
          </td>
        </tr>
        <tr>
          <td colspan="2" align="left">
            รอบ&nbsp;<span class="english-text">(Round)</span>&nbsp;&nbsp;{{
              round
            }}
          </td>
          <td colspan="2" align="left">
            โครงการ&nbsp;<span class="english-text">(Project)</span
            >&nbsp;&nbsp;{{ project }}
          </td>
        </tr>
        <tr>
          <td height="5"></td>
        </tr>
      </table>

      <!-- ตารางที่สมัคร -->
      <table class="center cell">
        <tr>
          <td width="7%">
            ลำดับที่เลือก
            <br />
            No.
          </td>
          <td width="20%">
            คณะ
            <br />
            Faculty
          </td>
          <td width="73%">
            หลักสูตร
            <br />
            Curriculum
          </td>
        </tr>

        <tr
          v-for="(item, index) in register_curriculum"
          :key="index"
          class="ml-5 mb-3"
        >
          <td>{{ index + 1 }}</td>
          <td align="left">
            {{ item.faculty_name_th }}<br />
            <span class="english-text"> {{ item.faculty_name_en }}</span>
            <br />
          </td>
          <td align="left">
            {{ item.curriculum_name_th }}
            <span v-if="item.branch_name_th"
              >แขนง {{ item.branch_name_th }}
            </span>
            | ประเภทรับเข้า : {{ item.study_admit_type_name_th }} | แผนการศึกษา
            :
            {{ item.study_plan_name_th }}
            | ช่วงเวลาเรียน :
            {{ item.study_classes_name_th }}
            <br />
            <span class="english-text">
              {{ item.curriculum_name_en }}
              <span v-if="item.branch_name_th"> </span>
              | Branch : {{ item.branch_name_en }} | Admission type :
              {{ item.study_admit_type_name_en }}
              | Plan :
              {{ item.study_plan_name_en }} | Class :
              {{ item.study_classes_name_en }}
            </span>
            <br />
          </td>
        </tr>
      </table>

      <br />
      <!-- ข้อมูลผู้สมัคร -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ข้อมูลผู้สมัคร
            <span class="english-text">(Applicant Information)</span>
          </td>
        </tr>
        <tr>
          <td align="left" width="50%">
            สัญชาติ <span class="english-text">(Nation)</span> : {{ nation }}
          </td>
          <td align="left" width="50%">
            วันเดือนปีเกิด <span class="english-text">(Birthday)</span> :
            {{ dateFromDBTranslatorTH(birthday) }}
          </td>
        </tr>
        <tr>
          <td align="left">Email : {{ email }}</td>
          <td align="left">
            เบอร์โทร <span class="english-text">(Mobile)</span> : {{ mobile }}
          </td>
        </tr>
      </table>

      <!-- ประวัติการศึกษาระดับปริญญาตรี -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการศึกษาระดับปริญญาตรี
            <span class="english-text"
              >(Education background (Undergraduate level))</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" width="50%">
            สถานภาพทางการศึกษา
            <span class="english-text">(Educational Status)</span> :
            {{ university_study_status_name_th }}
          </td>
          <td align="left" width="50%">
            มหาวิทยาลัย <span class="english-text">(University)</span> :
            {{ university_name }}
          </td>
        </tr>
        <tr>
          <td align="left">
            ปีที่สำเร็จการศึกษา (พศ.)
            <span class="english-text">(Year graduated (B.E.))</span> :
            {{ graduated_year }}
          </td>
          <td align="left">
            คุณวุฒิ/ปริญญา <span class="english-text">(Degree)</span> :
            {{ degree_name }}
          </td>
        </tr>
        <tr>
          <td align="left">
            สาขา
            <span class="english-text">(Curriculum)</span> :
            {{ curriculum_name }}
          </td>
          <td align="left">GPA : {{ GPA }}</td>
        </tr>
      </table>

      <!-- ประวัติการศึกษาระดับปริญญาโท (ถ้ามี) -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการศึกษาระดับปริญญาโท
            <span class="english-text"
              >(Education background (Master's degree))</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" width="50%">
            สถานภาพทางการศึกษา
            <span class="english-text">(Educational Status)</span> :
            {{ master_university_study_status_name_th }}
          </td>
          <td align="left" width="50%">
            มหาวิทยาลัย <span class="english-text">(University)</span> :
            {{ master_university_name }}
          </td>
        </tr>
        <tr>
          <td align="left">
            ปีที่สำเร็จการศึกษา (พศ.)
            <span class="english-text">(Year graduated (B.E.))</span> :
            {{ master_graduated_year }}
          </td>
          <td align="left">
            คุณวุฒิ/ปริญญา <span class="english-text">(Degree)</span> :
            {{ master_degree_name }}
          </td>
        </tr>
        <tr>
          <td align="left">
            สาขา
            <span class="english-text">(Curriculum)</span> :
            {{ master_curriculum_name }}
          </td>
          <td align="left">GPA : {{ master_GPA }}</td>
        </tr>
      </table>

      <!-- ประสบการณ์การทำงาน (ถ้ามี) -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประสบการณ์การทำงาน (ถ้ามี)
            <span class="english-text">(Work Experience (If any))</span>
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            จำนวนปีที่ทำงาน
            <span class="english-text">(Years of experience)</span> :
            {{ num_of_year_working }}
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            บริษัทที่ทำงาน (1)
            <span class="english-text">(Name of company (1))</span> :
            {{ company_name }}
          </td>
        </tr>
        <tr>
          <td align="left">
            เริ่มทำงานตั้งแต่ปี พ.ศ.
            <span class="english-text">(Since (B.E.))</span> :
            {{ since_working }}
          </td>
          <td align="left">
            ตำแหน่ง <span class="english-text">(Position)</span> :
            {{ position_in_company }}
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            บริษัทที่ทำงาน (2)
            <span class="english-text">(Name of company (2))</span> :
            {{ company_name_1 }}
          </td>
        </tr>
        <tr>
          <td align="left">
            เริ่มทำงานตั้งแต่ปี พ.ศ.
            <span class="english-text">(Since (B.E.))</span> :
            {{ since_working_1 }}
          </td>
          <td align="left">
            ตำแหน่ง <span class="english-text">(Position)</span> :
            {{ position_in_company_1 }}
          </td>
        </tr>
      </table>

      <table class="center">
        <tr>
          <td align="right">
            <span class="english-text">
              พิมพ์เมื่อวันที่ : {{ timestamp }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import authfoProvider from "@/services/auth.provider";
import refProvider from "@/services/ref.provider";
import payInSlipProvider from "@/services/pay_in_slip.provider";
import ApplicantInfoProvider from "@/services/applicant_info";
import {
  dateFromDBTranslatorTH,
  dateFromDBTranslatorEN,
} from "@/helper/translator";

const authService = new authfoProvider();
const payInSlipService = new payInSlipProvider();
const refService = new refProvider();
const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "scbSlip",
  props: ["register_id"],
  data: () => ({
    UID: null,

    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    Citizen_id: null,
    mobile: null,
    email: null,
    nation: null,
    birthday: null,

    university_study_status_name_th: null,
    university_name: null,
    graduated_year: null,
    degree_name: null,
    curriculum_name: null,
    GPA: null,

    master_university_study_status_name_th: null,
    master_university_name: null,
    master_graduated_year: null,
    master_degree_name: null,
    master_curriculum_name: null,
    master_GPA: null,

    num_of_year_working: null,
    company_name: null,
    since_working: null,
    position_in_company: null,
    company_name_1: null,
    since_working_1: null,
    position_in_company_1: null,

    registId: null,
    project: null,
    round: null,
    level_name_th: null,
    level_name_en: null,
    register_curriculum: null,
    created_at: null,

    timestamp: "",
  }),
  components: {
    // barcode: VueBarcode,
  },
  methods: {
    dateFromDBTranslatorTH,
    dateFromDBTranslatorEN,
    async fetch_data(UID) {
      // ข้อมูลผู้สมัคร
      const dataUserInfo = await authService.getUserInfo(UID);
      this.UserInfo_nameTh = dataUserInfo.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameTh = dataUserInfo.admission.STUDENT_LNAME_TH;
      this.Citizen_id = dataUserInfo.admission.CITIZEN_ID;
      this.mobile = dataUserInfo.admission.MOBILE;
      this.birthday = dataUserInfo.admission.BIRTHDAY;
      this.email = dataUserInfo.admission.EMAIL;
      this.prefix_name_id = dataUserInfo.admission.PREFIX_NAME_ID;
      // สัญชาติ
      const dataNation = await refService.getNationById(
        dataUserInfo.admission.NATION_ID
      );
      this.nation = dataNation[0].NATION_NAME_TH;
      // ข้อมูลการศึกษา (มหาวิทยาลัย)
      const dataEducation =
        await applicantInfoService.getApplicantInfoUniversity(UID);
      this.graduated_year = dataEducation.GRADUATED_YEAR;
      this.degree_name = dataEducation.DEGREE_NAME;
      this.curriculum_name = dataEducation.CURRICULUM_NAME;
      this.GPA = dataEducation.GPA;
      this.master_graduated_year = dataEducation.MASTER_GRADUATED_YEAR;
      this.master_degree_name = dataEducation.MASTER_DEGREE_NAME;
      this.master_curriculum_name = dataEducation.MASTER_CURRICULUM_NAME;
      this.master_GPA = dataEducation.MASTER_GPA;

      this.num_of_year_working = dataEducation.NUM_OF_YEAR_WORKING;
      this.company_name = dataEducation.COMPANY_NAME;
      this.since_working = dataEducation.SINCE_WORKING;
      this.position_in_company = dataEducation.POSITION_IN_COMPANY;
      this.company_name_1 = dataEducation.COMPANY_NAME_1;
      this.since_working_1 = dataEducation.SINCE_WORKING_1;
      this.position_in_company_1 = dataEducation.POSITION_IN_COMPANY_1;
      //-------------------------------------------------------(ตอน ป.ตรี)
      // ชื่อ มหาวิทยาลัย
      if (dataEducation.COUNTRY_ID_OF_UNIVERSITY === "TH") {
        const dataUniversity = await refService.getUniversityById(
          dataEducation.UNIVERSITY_ID
        );
        this.university_name = dataUniversity[0].UNIVERSITY_NAME_TH;
      } else {
        this.university_name = dataEducation.UNIVERSITY_NAME;
      }
      // สถานภาพทางการศึกษา
      const dataUniversityStudyStatus =
        await refService.getUniversityStudyStatusById(
          dataEducation.UNIVERSITY_STUDY_STATUS
        );
      this.university_study_status_name_th =
        dataUniversityStudyStatus[0].UNIVERSITY_STUDY_STATUS_NAME_TH;
      //-------------------------------------------------------(ตอน บัณฑิต)
      // ชื่อ มหาวิทยาลัย
      if (dataEducation.MASTER_COUNTRY_ID_OF_UNIVERSITY === "TH") {
        const dataMasterUniversity = await refService.getUniversityById(
          dataEducation.MASTER_UNIVERSITY_ID
        );
        this.master_university_name =
          dataMasterUniversity[0].UNIVERSITY_NAME_TH;
      } else {
        this.master_university_name = dataEducation.MASTER_UNIVERSITY_NAME;
      }
      // สถานภาพทางการศึกษา
      if (dataEducation.MASTER_UNIVERSITY_STUDY_STATUS) {
        const dataMasterUniversityStudyStatus =
          await refService.getUniversityStudyStatusById(
            dataEducation.MASTER_UNIVERSITY_STUDY_STATUS
          );
        this.master_university_study_status_name_th =
          dataMasterUniversityStudyStatus[0].UNIVERSITY_STUDY_STATUS_NAME_TH;
      }
      // ข้อมูลหลักสูตรที่สมัคร
      const uid = localStorage.getItem("uid");
      const dataApplication = await payInSlipService.getPaymentApplicationFee(
        parseInt(this.register_id),
        uid
      );
      this.created_at = dataApplication.created_at.substring(0, 10);
      this.registId = dataApplication.register_id;
      this.project = dataApplication.project_name_th;
      this.round = dataApplication.round_name_th;
      this.level_name_th = dataApplication.level_name_th;
      this.level_name_en = dataApplication.level_name_en;
      this.register_curriculum = dataApplication.register_curriculum;
    },

    getNow: function () {
      const today = new Date();
      const date = dateFromDBTranslatorTH(today);
      const time =
        today.getHours() +
        ":" +
        (today.getMinutes() < 10 ? "0" : "") +
        today.getMinutes() +
        ":" +
        (today.getSeconds() < 10 ? "0" : "") +
        today.getSeconds();
      const dateTime = date + " " + time;
      this.timestamp = dateTime;
    },
    createPDF() {
      var sTable = document.getElementById("tab").innerHTML;

      var style = "<style>";
      style =
        style +
        "@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');";
      style = style + "body{font-family: 'Sarabun', sans-serif;}";
      style = style + "ul {list-style-type: none; padding: 0;}";
      style = style + "li {display: inline-block; margin: 0 10px;}";
      style = style + "a {color: #42b983;}";
      style = style + "u {text-decoration: underline;}";
      style =
        style + "span1 {border-bottom:solid black 1px; padding-right:10rem;}";
      style = style + "table {width:100%;}";
      style =
        style +
        "table, th, td, tr {table-layout: fixed; overflow: hidden; padding: 2px 3px;}";
      style =
        style +
        "table.center {width:100%; margin-left : auto; margin-right : auto; font-size: 12px;}";
      style =
        style +
        ".cell {vertical-align : middle; text-align : center; width : 100%; border-collapse: collapse;";
      style =
        style + "border-top: double; border-top-width: 4px; font-size:12px;}";
      style =
        style + ".cell th {border:1px solid #C0C0C0; background:#F0F0F0;}";
      style =
        style +
        ".cell td {border:1px solid #C0C0C0; vertical-align:top; padding: 2px 4px;}";
      style =
        style +
        ".cell-total {vertical-align:middle; text-align:center; width:100%; ";
      style = style + "border-collapse:collapse; font-size:11px;}";
      style =
        style +
        ".cell-total th {border:1px solid #C0C0C0; background:#F0F0F0; font-size: 11px;}";
      style =
        style +
        ".cell-total td {border:1px solid #C0C0C0; vertical-align: top; ";
      style = style + "padding: 2px 4px; font-size: 11px;}";
      style =
        style +
        ".notice-box {padding: 10px 10px 10px 10px; outline-style: solid; outline-color: silver;";
      style =
        style + "outline-width: 1px; outline-offset: -10px; text-align: left;}";
      style = style + ".notice-box1 {text-align: center; color: red;}";
      style = style + ".tab1 {padding-left: 2em;}";
      style = style + ".mini-font-right {font-size: 11px; text-align: right;}";
      style = style + ".mini-font-left {font-size: 9px; text-align: left;}";
      style = style + ".mini-font {font-size: 11px; text-align: center;}";
      style = style + ".seperate-page {font-size: 8px; text-align: center;}";
      style =
        style + ".bigger-mini-font-right {font-size: 12px; text-align: right;}";
      style =
        style + ".bigger-mini-font-left {font-size: 12px; text-align: left;}";
      style =
        style +
        ".sub-table {width : 40%; border-collapse: collapse; border: 1px solid gray;}";
      style =
        style +
        ".english-text {color: #696969; padding-top: -2em; font-size: 9px}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      // var win = window.open('', '', 'height=700,width=700');
      var win = window.open("", "");

      win.document.write("<html><head>");
      win.document.write("<title>ใบสมัครสอบ สจล.</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      // win.close(); // CLOSE THE CURRENT WINDOW.

      setTimeout(function () {
        win.print();
      }, 100); // PRINT THE CONTENTS.
    },
  },

  created() {
    const url_data = this.$route.query;
    const uid = url_data.uid ?? localStorage.getItem("uid");
    this.fetch_data(uid);
    setInterval(this.getNow, 1000);
  },
};
</script>

<style scoped>
.svg-container {
  width: 80%;
}
body {
  width: 90%;
  margin: auto;
  font-family: "Sarabun", sans-serif;
  font-size: 13px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
u {
  text-decoration: underline;
}
/* p {
            border-bottom: solid white 1px;
        } */
.span1 {
  border-bottom: solid black 1px;
  padding-right: 5rem;
}

/* table */
table,
th,
td,
tr {
  table-layout: fixed;
  overflow: hidden;
}
table.center {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.cell {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  border-top: double;
  border-top-width: 4px;
  font-size: 12px;
}
.cell th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
}
.cell td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
}

.cell-total {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
.cell-total th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
  font-size: 11px;
}
.cell-total td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
  font-size: 11px;
}

.notice-box {
  padding: 10px 10px 10px 10px;
  outline-style: solid;
  outline-color: silver;
  outline-width: 1px;
  outline-offset: -10px;
  text-align: left;
}

.notice-box1 {
  text-align: center;
  color: red;
}

.tab1 {
  padding-left: 2em;
}

.mini-font-right {
  font-size: 11px;
  text-align: right;
}
.mini-font-left {
  font-size: 9px;
  text-align: left;
}
.mini-font {
  font-size: 11px;
  text-align: center;
}

.seperate-page {
  font-size: 8px;
  text-align: center;
}

.bigger-mini-font-right {
  font-size: 12px;
  text-align: right;
}
.bigger-mini-font-left {
  font-size: 12px;
  text-align: left;
}

.sub-table {
  width: 22%;
  border-collapse: collapse;
  border: 1px solid gray;
}

.english-text {
  color: #696969;
  padding-top: -2em;
}

.button {
  border-radius: 36px;
  background-color: #ffc107;
  border: none;
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  padding: 15px;
  width: 100%;
  transition: all 0.3s;
  cursor: pointer;
}
/* .button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.3s;
}
.button span:after {
  content: "<< CLICK >>";
  font-size: 16px;
  position: relative;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.3s;
}
.button:hover span {
  padding-right: 100px;
}
.button:hover span:after {
  opacity: 1;
  right: 0;
} */
</style>
